import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=d7865ef4"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=d7865ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports